import { Directive, Input, OnInit, ElementRef, OnDestroy, ViewContainerRef } from "@angular/core";
import { Subscription } from 'rxjs';
import { AuthenticationService } from "../authentication/services/authentication.service";
import { USER_MGMT_CNST } from '../../constants/proj.cnst';
import { DataService } from "../../services/data.service";
import { EnvService } from "../../services/env.service";
import { AppStateService } from "../../services/app-state.service";
import { UtilsService } from "../../services/utils.service";
import { HttpService } from "../../services/http.service";
import { isNullOrUndefined } from "../../shared/common-utils";

@Directive({
  selector: '[permissions]'
})
export class PermissionsDirective implements OnInit, OnDestroy {
  @Input('resourceName') resourceName: any;
  @Input('permission') permission: any;

  currentApplication: any;
  subscriptions: Subscription[] = [];
  userPermissions: any = {};

  constructor(
    private appStateSrv: AppStateService,
    private elementRef: ElementRef,
    private utilSrv: UtilsService,
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private viewContainer: ViewContainerRef,
    private envService: EnvService,
    private authSrv: AuthenticationService
  ) { }

  ngOnInit() {
    this.initialize();
  }

  initialize() {
    this.currentApplication = USER_MGMT_CNST.CURRENT_USERMANAGEMENT_APPLICATION;
    this.viewContainer.clear();
    this.userPermissions = this.appStateSrv.getUserPermissions();

    if (this.appStateSrv.getPermissionsLoaded()) {
      this.checkPermissions();
    } else if (this.appStateSrv.getInProcess()) {
      this.registerCallBack();
    } else {
      this.fetchUserPermissions();
    }

    const userPermissionsRef = this.appStateSrv.userPermissionsRef.subscribe((response: any) => {
      this.userPermissions = { ...response };
    });
    this.subscriptions.push(userPermissionsRef);
  }

  fetchUserPermissions() {
    const userId = this.authSrv.getUserId();
    if (!userId) {
      this.hideElement();
      return;
    }

    this.appStateSrv.setInProcess(true);
    let options = { uriParams: { userId } };
    console.log("fetching user permissions");
    this.httpSrv
      .makeGetApiCall('GET_USER_PERMISSIONS', this.envService.baseUrl, options)
      .subscribe((res: any) => {
        if (!isNullOrUndefined(res.response)) {
          this.handlePermissionsResponse(res.response);
        } else {
          this.utilSrv.showToastMessage("User Not Found", "error");
        }
      });
  }

  handlePermissionsResponse(response: any) {
    this.appStateSrv.setPermissionsLoaded(true);
    this.userPermissions = response?.permissions ? response.permissions : {};
    let metaInfo = response?.meta ? response.meta : {};
    this.appStateSrv.setLoggedInUserType(response);
    this.appStateSrv.setUserMetaInfo(metaInfo);
    this.appStateSrv.setUserPermissionsRef(this.userPermissions);
    this.checkPermissions();
  }

  hideElement() {
    this.elementRef.nativeElement.style.display = "none";
    this.viewContainer.clear();
  }

  registerCallBack() {
    const permissionsRef = this.appStateSrv.userPermissionsRef.subscribe((response: any) => {
      this.userPermissions = response;
      permissionsRef.unsubscribe();
      this.checkPermissions();
    });
  }

  checkPermissions() {
    if (!isNullOrUndefined(this.permission)) {
      this.elementRef.nativeElement.style.display = this.doesResourceHaveValidPermission(this.resourceName, this.permission) ? "block" : "none";
      this.viewContainer.clear();
    } else {
      this.elementRef.nativeElement.style.display = this.doesResourceExistInApplication(this.resourceName) ? "block" : "none";
      this.viewContainer.clear();
    }
  }

  doesResourceHaveValidPermission(resourceName: string, permission: string): boolean {
    if (this.currentApplication in this.userPermissions) {
      let resSettings = this.userPermissions[this.currentApplication].resources;
      if (resourceName in resSettings) {
        return resSettings[resourceName].actions.indexOf(permission) !== -1;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  doesResourceExistInApplication(resourceName: string): boolean {
    if ('Inside Sales' in this.userPermissions && this.userPermissions["Inside Sales"]["resources"][resourceName]) {
      return true;
    } else if (!(this.currentApplication in this.userPermissions)) {
      return false;
    }
    return !!this.userPermissions[USER_MGMT_CNST.CURRENT_USERMANAGEMENT_APPLICATION]?.["resources"]?.[resourceName];
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
}
